module.exports = __webpack_public_path__ + "img/LOGO_AZUL.733d77fb.svg";